<template>
  <div class="info-container">
      <div class="column items-center q-gutter-sm q-mb-lg">



        <AppointmentPicker
          v-model="appointment"
          @update:selectedAppointment="selected = $event"
        />


        <div class="row">
          <q-btn
            no-caps
            flat
            size="lg"
            color="primary"
            label="Back"
            icon="arrow_back_ios"
            @click="router.back()"
          />
                  <q-btn
            no-caps
            flat
            size="lg"
            color="primary"
            label="Next"
            icon-right="arrow_forward_ios"
            :to="`/en/pay?a=${appointment?.id}&s=${appointment?.start.getTime()}`"
          />
        </div>
       

      <q-btn
        no-caps
        flat
        size="sm"
        color="primary"
        class="legal-button"
        label="Imprint and data protection"
        to="/en/data-protection-imprint"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import AppointmentPicker from '@/components/AppointmentPicker.vue'
import {Appointment} from "@/models/appointment";

const router = useRouter()
const appointment = ref<Appointment | null>(null)
const selected = ref<any>(null)
</script>
